import i18n from '@/i18n/i18n'
import CategoryService from '@/services/admin/CategoryService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = [
  'address.city_id',
  'id',
  'address.city.region.id',
  'categories.id',
  'salesChannels.id',
  'rank.id',
  'name'
]

export const state = {
  categories: null,
  category: {},
  brands: null
}

export const mutations = {
  SET_CATEGORIES(state, categories) {
    state.categories = categories.data
  },
  SET_CATEGORY(state, category) {
    state.category = category
  },
  ADD_CATEGORY(state, category) {
    state.categories.push(category)
  },
  SET_BRANDS(state, brands) {
    state.brands = brands
  },
  SET_CATEGORY_VALUE(state, parameters) {
    state.category[parameters.type] = parameters.value
  }
}

export const getters = {
  getCategoryById: state => id => {
    return state.categories ? state.categories.find(category => category.id === id) : false
  }
}

export const actions = {
  setCategoryValue({ commit }, parameters) {
    commit('SET_CATEGORY_VALUE', parameters)
  },
  getCategories({ commit, dispatch, state }, query) {
    let allowedFilters = query && query.allowedFilters ? query.allowedFilters : ''
    let allowedIncludes = query && query.allowedIncludes ? query.allowedIncludes : ''
    let allowedSorts = query && query.allowedSorts ? query.allowedSorts : ''

    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts)

    return new Promise((resolve, reject) => {
      CategoryService.getCategories(newQuery)
        .then(response => {
          commit('SET_CATEGORIES', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.category.categories')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCategory({ commit, state, getters }, id) {
    if (id == state.category.id) return state.category

    let category = getters.getCategoryById(id)

    if (category) {
      commit('SET_CATEGORY', category)
      return category
    } else {
      return new Promise(resolve => {
        CategoryService.getCategory(id).then(response => {
          commit('SET_CATEGORY', response.data)
          resolve(response.data)
        })
      })
    }
  },
  editCategory({ dispatch, commit }, category) {
    return new Promise((resolve, reject) => {
      CategoryService.editCategory(category.id, category)
        .then(response => {
          commit('SET_CATEGORY', category)
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.category.categorie')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.category.categorie')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createCategory({ dispatch, commit, state }, category) {
    return new Promise((resolve, reject) => {
      CategoryService.createCategory(category)
        .then(response => {
          if (state.categories) {
            commit('ADD_CATEGORY', response.data)
          }

          const notification = {
            type: 'success',
            message: t('store.shared.created', {
              element: t('store.admin.category.new_categorie')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.create_error', {
                element: t('store.admin.category.new_categorie')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteCategory({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      CategoryService.deleteCategory(params.id)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('store.admin.category.categorie')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.delete_error', {
              element: t('store.admin.category.categorie')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBrands({ commit, dispatch }, categoryId) {
    return new Promise((resolve, reject) => {
      CategoryService.getBrands(categoryId)
        .then(response => {
          commit('SET_BRANDS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.category.categorie_brands')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  attachBrand({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CategoryService.attachBrand(params.categoryId, params.brandIds)
        .then(response => {
          commit('SET_BRANDS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.category.categorie_brands')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  removeBrand({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      CategoryService.removeBrand(params.categoryId, params.brandId)
        .then(response => {
          commit('SET_BRANDS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.delete_error', {
                element: t('store.admin.category.categorie_brand')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
